"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromoFields = void 0;
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
function PromoFields(_a) {
    var voucher = _a.voucher, setVoucher = _a.setVoucher;
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: 'grid grid-cols-3 gap-4' },
            react_1.default.createElement("div", null,
                react_1.default.createElement(storybook_1.Forms.Label, null, "KORTING OP"),
                react_1.default.createElement(storybook_1.Forms.Field, null,
                    react_1.default.createElement(storybook_1.Forms.Select, { value: voucher.promo_type, onChange: function (promo_type) { return setVoucher({ promo_type: promo_type }); } },
                        react_1.default.createElement("option", { value: 'pay_per_view' }, "Pay-per-view"),
                        react_1.default.createElement("option", { value: 'subscriptions', disabled: true }, "Abonnementen")))),
            react_1.default.createElement("div", null,
                react_1.default.createElement(storybook_1.Forms.Label, null, "TYPE KORTING"),
                react_1.default.createElement(storybook_1.Forms.Field, null,
                    react_1.default.createElement(storybook_1.Forms.Select, { value: voucher.promo_unit, onChange: function (promo_unit) { return setVoucher({ promo_unit: promo_unit }); } },
                        react_1.default.createElement("option", { value: 'percentage' }, "Percentage"),
                        react_1.default.createElement("option", { value: 'amount' }, "Bedrag")))),
            react_1.default.createElement("div", null,
                react_1.default.createElement(storybook_1.Forms.Label, null,
                    "KORTING ",
                    voucher.promo_unit === 'amount' ? '€' : '%'),
                react_1.default.createElement(storybook_1.Forms.Field, null,
                    react_1.default.createElement(storybook_1.Forms.Input, { type: 'number', placeholder: '0', value: voucher.promo_amount, onChange: function (promo_amount) {
                            setVoucher({ promo_amount: promo_amount });
                        } })))),
        react_1.default.createElement(storybook_1.Forms.Field, null,
            react_1.default.createElement(storybook_1.Texts.Small, null, "Stel de korting van de promo code in. Pay-per-view geeft een eenmalige korting op een bepaalde video of livestream. Subscription geeft een terugkerende korting op abonnementsgelden.")));
}
exports.PromoFields = PromoFields;
